import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { createSurvey } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { questions, jobs, ...otherValues } = values;

  const filteredValues = Object.fromEntries(
    Object.entries(otherValues).filter(
      ([_, v]) => v !== "" && v !== undefined && v !== null
    )
  );
  
  // Set expiry date to 60 days from now
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 60);
  filteredValues.expires_at = expiryDate.toISOString();
  
  if (Array.isArray(jobs)) {
    filteredValues.jobs = jobs.map((job) => ({ job }));
  }
  if (Array.isArray(questions)) {
    filteredValues.questions = questions.map((question) => ({ question: question }));
  }
  return filteredValues;
}

export function useCreateSurvey() {
  return useMutation({
    mutationFn: async ({ item }) => {
      const payload = buildPayload(item);
      const response = await createSurvey({ item: payload });
      return response;
    },
    onSuccess: () => {
      toast.success("Survey Created Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
